import { Button, Input, Select } from '@/components';
import { NATIONAL_LIST } from '@/constant';
import { memo, useCallback } from 'react';

import { SearchType, TYPE_SEARCH_UNIT_OPTIONS } from './config';
import { TFilter } from './type';

export type TFormSearchForeignBusiness = {
	filter: TFilter;
	handleChangeSelect: (value: string) => void;
	handleChangeKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
	handleSelectNational: (value: string) => void;
	onSearch: () => void;
};

const FormSearchForeignBusiness = ({
	filter,
	handleChangeSelect,
	handleChangeKeyword,
	handleSelectNational,
	onSearch,
}: TFormSearchForeignBusiness) => {
	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				onSearch();
			}
		},
		[onSearch]
	);

	return (
		<div className="grid pt-5 grid-cols-3">
			<div className="col-span-2 grid grid-cols-3">
				<div className={'flex flex-row items-center col-span-2 gap-2'}>
					<Select
						value={filter.valueSelect}
						options={TYPE_SEARCH_UNIT_OPTIONS}
						onChange={handleChangeSelect}
					/>
					{filter.valueSelect !== SearchType.NATIONAL ? (
						<Input
							value={filter.keyword}
							onChange={handleChangeKeyword}
							inputClassName="w-[250px]"
							onPressEnter={onSearch}
						/>
					) : (
						<Select
							options={NATIONAL_LIST}
							value={filter.keyword}
							containerClassName="w-[250px]"
							onKeyDown={handleKeyDown}
							placeholder="선택"
							onChange={handleSelectNational}
							showSearch
						/>
					)}

					<Button secondary onClick={onSearch}>
						검색
					</Button>
				</div>
			</div>
		</div>
	);
};

export default memo(FormSearchForeignBusiness);
